<!-- Blog details -->
<section class="our-articles bg-light-theme section-padding pt-0">
  <div class="blog-page-banner"></div>
  <div class="container-fluid">
    <div class="row">
      <!-- Left sidebar mirrors store detail: restaurant left sidebar -->
      <aside class="col-lg-3 sidebar-offset">
        <app-restaurantleftsidebar
          [storeId]="post?.storeId || storeInfo?.id || null"
        ></app-restaurantleftsidebar>
      </aside>

      <!-- Main content with services in center, like store detail -->
      <div class="col-lg-6 blog-inner clearfix">
        <div class="main-box padding-20 full-width">
          <div class="breadcrumb-wrpr">
            <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <a routerLink="/" class="text-light-black">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a routerLink="/blog" class="text-light-black">Blog</a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Blog Details
              </li>
            </ul>
          </div>

          <!-- Loading Skeleton -->
          <div *ngIf="isLoading">
            <div class="post-wrapper mb-xl-20">
              <div class="skeleton-container">
                <div
                  class="skeleton-image"
                  style="width: 100%; padding-bottom: 100%; border-radius: 4px"
                ></div>
              </div>
            </div>
            <div class="blog-meta mb-xl-20 post-info-card">
              <div class="d-flex align-items-center mb-3">
                <div class="author-avatar mr-3">
                  <div
                    class="skeleton-image img-rounded"
                    style="width: 60px; height: 60px"
                  ></div>
                </div>
                <div style="flex: 1">
                  <div
                    class="skeleton-text"
                    style="width: 200px; height: 24px; margin-bottom: 8px"
                  ></div>
                  <div
                    class="skeleton-text"
                    style="width: 250px; height: 16px"
                  ></div>
                </div>
              </div>
              <div
                class="skeleton-text"
                style="width: 100px; height: 24px; margin-bottom: 12px"
              ></div>
              <div
                class="skeleton-text"
                style="width: 150px; height: 16px"
              ></div>
            </div>
            <div class="row">
              <div class="col-12">
                <div
                  class="skeleton-text"
                  style="width: 100%; height: 200px; border-radius: 4px"
                ></div>
              </div>
            </div>
          </div>
          <div class="py-4 text-center" *ngIf="!isLoading && error">
            <p class="text-light-black mb-2">{{ error }}</p>
            <a routerLink="/blog" class="btn btn-primary btn-sm"
              >Back to blog</a
            >
          </div>

          <ng-container *ngIf="!isLoading && !error && post as postData">
            <!-- Hero images (before/after slider) -->
            <div class="post-wrapper mb-xl-20">
              <div
                class="image-container"
                #revealContainer
                (mousedown)="startDrag($event)"
                (mousemove)="onDrag($event)"
                (mouseup)="endDrag()"
                (mouseleave)="endDrag()"
                (touchstart)="startDrag($event)"
                (touchmove)="onDrag($event)"
                (touchend)="endDrag()"
              >
                <img
                  class="before-image"
                  [src]="beforeUrl"
                  [alt]="postData.storeName"
                  [style.clip-path]="getBeforeClipPath()"
                  draggable="false"
                />
                <img
                  class="after-image"
                  [src]="afterUrl"
                  [alt]="postData.storeName"
                  [style.clip-path]="getAfterClipPath()"
                  draggable="false"
                />
                <div class="drag-handle" [style.left]="getDividerPosition()">
                  <div class="handle-arrows">
                    <div class="arrow-left"></div>
                    <div class="arrow-right"></div>
                  </div>
                </div>
                <div class="label-before" *ngIf="shouldShowBeforeLabel()">
                  Before
                </div>
                <div class="label-after" *ngIf="shouldShowAfterLabel()">
                  After
                </div>
                <div class="instruction">Drag to compare</div>
              </div>
            </div>

            <!-- Post info card -->
            <div class="blog-meta mb-xl-20 post-info-card">
              <div class="d-flex align-items-center mb-3" style="gap: 20px">
                <div class="author-avatar">
                  <img
                    [src]="postData.userInfo?.photoUrl"
                    [alt]="postData.userInfo?.name || 'Author'"
                  />
                </div>
                <div>
                  <h4
                    routerLink="/businesses/{{ postData.storeId }}"
                    style="cursor: pointer; font-size: 20px"
                    class="blog-title text-light-black mb-1"
                  >
                    {{ postData.storeName }}
                  </h4>
                  <p class="text-light-white mb-0 fs-14">
                    {{ postData.userInfo?.name || "Unknown author" }} -
                    {{ postData.createdTime | date : "longDate" }}
                  </p>
                </div>
              </div>
              <div class="badges mb-2" *ngIf="postData.topics?.length">
                <span
                  class="badge badge-light mr-2"
                  *ngFor="let t of postData.topics"
                  >{{ t | storeType }}</span
                >
              </div>
              <div class="text-light-white fs-14">
                <span class="mr-3"
                  ><i class="far fa-thumbs-up mr-1"></i
                  >{{ postData.likesCount }}</span
                >
                <span class="mr-3"
                  ><i class="far fa-bookmark mr-1"></i
                  >{{ postData.savesCount }}</span
                >
                <span class="mr-3"
                  ><i class="far fa-share-square mr-1"></i
                  >{{ postData.sharesCount }}</span
                >
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <!-- Booking section exactly like store detail in center -->
                <section
                  class="section-padding restaurent-meals"
                  *ngIf="storeInfo"
                >
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col-xl-12 col-lg-12">
                        <div class="row">
                          <div class="col-lg-12 restaurent-meal-head mb-md-40">
                            <div class="card">
                              <div class="card-header">
                                <div class="section-header-left">
                                  <h3 class="text-light-black header-title">
                                    <a
                                      class="card-link text-light-black no-margin"
                                      data-toggle="collapse"
                                      href="#collapseMostPopular"
                                      >Most Popular</a
                                    >
                                  </h3>
                                </div>
                              </div>
                              <div
                                id="collapseMostPopular"
                                class="collapse show"
                              >
                                <div class="card-body no-padding">
                                  <div
                                    *ngIf="getFeaturedServices().length === 0"
                                    class="text-center"
                                    style="padding: 20px"
                                  >
                                    <p class="text-light-black">
                                      No featured services available.
                                    </p>
                                  </div>
                                  <div
                                    class="row"
                                    *ngIf="getFeaturedServices().length > 0"
                                  >
                                    <div
                                      class="col-lg-12"
                                      *ngFor="
                                        let service of getFeaturedServices()
                                      "
                                    >
                                      <div class="restaurent-product-list">
                                        <div class="restaurent-product-detail">
                                          <div class="restaurent-product-left">
                                            <div
                                              class="restaurent-product-title-box"
                                            >
                                              <div
                                                class="restaurent-product-box"
                                              >
                                                <div
                                                  class="restaurent-product-title"
                                                >
                                                  <h6 class="mb-2">
                                                    <a
                                                      href="javascript:void(0)"
                                                      class="text-light-black fw-600"
                                                      >{{ service.name }}</a
                                                    >
                                                  </h6>
                                                  <p class="text-light-white">
                                                    {{
                                                      formatDuration(
                                                        service.duration
                                                      )
                                                    }}
                                                  </p>
                                                </div>
                                                <div
                                                  class="restaurent-product-label"
                                                  *ngIf="service.isFeature"
                                                >
                                                  <span
                                                    class="rectangle-tag bg-gradient-red text-custom-white"
                                                    >Featured</span
                                                  >
                                                </div>
                                              </div>
                                              <div
                                                class="restaurent-product-rating"
                                                *ngIf="
                                                  service.items &&
                                                  service.items.length > 0
                                                "
                                              >
                                                <div class="rating-text">
                                                  <p
                                                    class="text-light-white fs-12 title"
                                                  >
                                                    {{ service.items.length }}
                                                    service(s) included
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                            <div
                                              class="restaurent-product-caption-box"
                                              *ngIf="
                                                service.items &&
                                                service.items.length > 0
                                              "
                                            >
                                              <span class="text-light-white"
                                                >Includes:
                                                {{
                                                  formatServiceItems(service)
                                                }}</span
                                              >
                                            </div>
                                            <div class="restaurent-tags-price">
                                              <div
                                                class="restaurent-product-price"
                                              >
                                                <h6
                                                  class="text-success fw-600 no-margin"
                                                >
                                                  {{
                                                    formatPrice(
                                                      service.totalPrice
                                                    )
                                                  }}+
                                                </h6>
                                              </div>
                                              <div class="mt-2">
                                                <button
                                                  type="button"
                                                  class="btn btn-sm btn-primary"
                                                  (click)="
                                                    addServiceToCart(service)
                                                  "
                                                >
                                                  <i
                                                    class="fas fa-shopping-cart"
                                                  ></i>
                                                  Add to Cart
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="restaurent-product-img">
                                            <img
                                              [src]="service.photoUrl"
                                              class="img-fluid"
                                              [alt]="service.name"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Right sidebar mirrors store detail: restaurant right sidebar -->
      <aside class="col-lg-3 sidebar-offset">
        <app-booking-custom-sidebar
          [storeId]="post?.storeId || storeInfo?.id || null"
        ></app-booking-custom-sidebar>
      </aside>
    </div>
  </div>
</section>
